import type { ConfigType, ManipulateType, OptionType, OpUnitType } from 'dayjs'
import dayjs from 'dayjs'
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import ru from 'dayjs/locale/ru'

export * from './format'

dayjs.extend(localizedFormatPlugin)
dayjs.extend(customParseFormat)
dayjs.locale(ru)

export function diffDays(date1: ConfigType, date2: ConfigType): number {
  return dayjs(date1).startOf('day').diff(dayjs(date2).startOf('day'), 'day')
}

export function diffYears(date1: ConfigType, date2: ConfigType): number {
  return dayjs(date1).startOf('day').diff(dayjs(date2).startOf('day'), 'year')
}

export function diffMonths(date1: ConfigType, date2: ConfigType): number {
  return dayjs(date1).startOf('day').diff(dayjs(date2).startOf('day'), 'month')
}

export function diffSeconds(date1: ConfigType, date2: ConfigType): number {
  return dayjs(date1).diff(dayjs(date2), 'seconds')
}

export function toDateEndOf(value: ConfigType, unit: OpUnitType): Date {
  return dayjs(value).endOf(unit).toDate()
}

export function toDateStartOf(value: ConfigType, unit: OpUnitType): Date {
  return dayjs(value).startOf(unit).toDate()
}

export function getAge(birthDay: ConfigType): number {
  return diffYears(new Date(), birthDay)
}

export function isFutureDate(value: ConfigType, compareDate: ConfigType = new Date()): boolean {
  return toDateStartOf(value, 'day') > toDateStartOf(compareDate, 'day')
}

export function isFutureTime(value: ConfigType, compareDate?: ConfigType): boolean {
  return dayjs(value).toDate() > dayjs(compareDate || new Date()).toDate()
}

export function isCurrentDate(value: ConfigType, compareDate?: ConfigType, unit?: OpUnitType): boolean {
  return dayjs(value).isSame(compareDate || new Date(), unit)
}

export function addTime(value: number, unit: ManipulateType, date?: ConfigType): Date {
  return dayjs(date ?? new Date())
    .add(value, unit)
    .toDate()
}

export function toDate(value: ConfigType, format?: OptionType): Date {
  return dayjs(value, format).toDate()
}

export function createDate(year: number, month: number, day: number): Date {
  return dayjs()
    .year(year)
    .month(month - 1)
    .date(day)
    .startOf('day')
    .toDate()
}
